import { useEffect } from "react";

const useHotKey = (hotKey: string, callback: () => void): void => {
  useEffect(() => {
    const downKeys: Set<string> = new Set();
    const hotKeyArray = hotKey.split("+").map((k) => k.trim());

    const handleKeyDown = (event: KeyboardEvent) => {
      downKeys.add(event.key);
      if (hotKeyArray.every((k) => downKeys.has(k))) {
        callback();
      }
    };

    const handleKeyUp = (event: KeyboardEvent) => {
      downKeys.delete(event.key);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [hotKey, callback]);
};

export { useHotKey };
